/**
 * https://assets.msn.com/staticsb/statics/latest/msstart-games-sdk/documentation/docs/in-game-rewarded-ads-apis/index.html
 * https://assets.msn.com/staticsb/statics/latest/msstart-games-sdk/documentation/docs/in-game-interstitial-ads-apis/index.html
 *
 * https://www.msn.com/en-us/play/games/testing/cg-test-game?dev-playground=https://mergecraft-staging.labsystech.ru/publish/html5-staging/msstart&item=flights:prg-cg-in-gm-rwd-ads
 *
 * Created by Aleksandr on 16.06.2023
 */

const MSStartAds = function () {
    AdsPlugin.call(this, connector.MSSTART, {
        sdk: SdkManager.SDK_MSSTART,
        cantLoadAndPlayInParallel: true,
        cantLoadAfterPlay: true,
        expirationPeriod: connector.utils.parseInterval("15 minutes")
    });
};

MSStartAds.prototype = Object.create(AdsPlugin.prototype);
MSStartAds.prototype.constructor = MSStartAds;

MSStartAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.MSSTART);// && !connector.config.debugMode;
};

MSStartAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

MSStartAds.prototype._cacheAd = function (name, callback) {
    $msstart.loadAdsAsync(name === AdsPlugin.REWARDED).then((adInstance) => {
        this.adBlockerDetected = false;
        callback(connector.CODE_SUCCEED, { instanceId: adInstance.instanceId });
    }).catch((error) => {
        this._trackAdBlock(error);
        const errorCode = this.extractErrorCode(error);

        callback(`ads_loading_${String(errorCode).toLowerCase().replace(/[^a-z0-9]+/g, "_").substring(0, 26)}`);

        this.bus.trigger("error:details:msstart:cache", errorCode, error);
    });
};

MSStartAds.prototype._playAd = function (name, adInstance, callback) {
    const onFinish = connector.utils.once(callback);

    const onError = (notShown) => (error) => {
        this._trackAdBlock(error);
        const errorCode = this.extractErrorCode(error);
        const adBlock = notShown && Boolean(error && error.extra && error.extra.adBlockerDetected);

        if (name === AdsPlugin.REWARDED) {
            onFinish(adBlock ? ERRORS.SHOW_REWARDED.AD_BLOCK : this.parseRewardedError(errorCode, notShown), error);
        } else {
            onFinish(adBlock ? ERRORS.SHOW_INTERSTITIAL.AD_BLOCK : this.parseInterstitialError(errorCode, notShown), error);
        }

        this.bus.trigger("error:details:msstart:play", errorCode, error);
    };

    const onShowRequestFailed = onError(true);
    const onCompletionFailed = onError(false);

    $msstart.showAdsAsync(adInstance.instanceId).then((adInstance) => {
        adInstance.showAdsCompletedAsync.then(() => {
            onFinish(connector.CODE_SUCCEED);
        }).catch(onCompletionFailed);
    }).catch(onShowRequestFailed);
};

MSStartAds.prototype.parseRewardedError = function (errorCode, notShown) {
    switch (errorCode) {
        case "REQUEST_THROTTLED":
        case "SHOWING_ADS_THROTTLED":
            return ERRORS.SHOW_REWARDED.THROTTLED;
        case "USER_CANCELED":
            return ERRORS.SHOW_REWARDED.CLOSED_BY_USER;
        case "EMPTY_VAST":
        case "NO_AD_NODE":
            return ERRORS.SHOW_REWARDED.NO_ADS;
        case "FAILED_BY_TIMEOUT":
        case "NO_LOADED_ADS_WITH_ID":
        default:
            return notShown ? ERRORS.SHOW_REWARDED.NO_ADS : ERRORS.SHOW_REWARDED.UNKNOWN;
    }
};

MSStartAds.prototype.parseInterstitialError = function (errorCode, notShown) {
    switch (errorCode) {
        case "REQUEST_THROTTLED":
        case "SHOWING_ADS_THROTTLED":
            return ERRORS.SHOW_INTERSTITIAL.THROTTLED;
        case "USER_CANCELED":
            return ERRORS.SHOW_INTERSTITIAL.CLOSED_BY_USER;
        case "EMPTY_VAST":
        case "NO_AD_NODE":
            return ERRORS.SHOW_INTERSTITIAL.NO_ADS;
        case "FAILED_BY_TIMEOUT":
        case "NO_LOADED_ADS_WITH_ID":
        default:
            return notShown ? ERRORS.SHOW_INTERSTITIAL.NO_ADS : ERRORS.SHOW_INTERSTITIAL.UNKNOWN;
    }
};

// MSStart includes `extra.adBlockerDetected` on load/play failures. Cache
// it on the plugin so AdsManager.checkAdBlock can return the authoritative
// signal instead of falling back to the generic DOM bait test.
MSStartAds.prototype._trackAdBlock = function (error) {
    if (error && error.extra && error.extra.adBlockerDetected) {
        this.adBlockerDetected = true;

        connector.ads.checkAdBlock();
    }
};

MSStartAds.prototype.checkAdBlock = function (callback) {
    callback(this.adBlockerDetected === true);
};

MSStartAds.prototype.extractErrorCode = function (originalError) {
    originalError = originalError || {};
    const extra = originalError.extra || {};

    // MSN ships LOAD failures with the canonical code in extra.subCode and
    // extra.error as a free-text string. SHOW failures put {code, message}
    // inside extra.error. The .message lookup below only handles the SHOW
    // shape, so honor subCode first.
    if (extra.subCode) {
        return extra.subCode;
    }

    const extraError = extra.error || {};
    let specialCode = {
        "No ad loader found.": "NO_AD_LOADER_FOUND",
        "Ads already loaded.": "AD_ALREADY_LOADED",
        "Ads is being loaded.": "AD_IS_BEING_LOADED",
        "No loaded ads with the given id found.": "NO_LOADED_ADS_WITH_ID",
        "Ad requires active tab.": "AD_REQUIRES_ACTIVE_TAB",
        "Failed by timeout.": "FAILED_BY_TIMEOUT", // code:COMPLETED_FAILURE,description:Showing In-Game Ads failed after started.
        "EMPTY VAST": "EMPTY_VAST",
        "NO AD NODE": "NO_AD_NODE"
    }[extraError.message];

    specialCode = specialCode || {
        "User closed rewarded ad before completion.": "USER_CANCELED"
    }[originalError.description];

    if (specialCode) {
        return specialCode;
    }

    if (extraError.code === 0) {
        extraError.code = "0";
    }

    const errorCode = originalError.code.replace("LOAD_ADS_CLIENT_FAILURE", "LOAD_ADS_FAILURE")
        .replace("LOAD_ADS_", "")
        .replace("SHOW_ADS_CLIENT_FAILURE", "SHOW_ADS_FAILURE")
        .replace("SHOW_ADS_", "");

    return errorCode + (extraError.code || "");
};